// extracted by mini-css-extract-plugin
module.exports = {"tag":"_9e1425b4d3--tag--mFV6R","tag_content":"_9e1425b4d3--tag_content--yXJ9L","tag_close":"_9e1425b4d3--tag_close--scja_"};